import React, { Suspense } from 'react'
import { Outlet } from 'react-router'
import { Container, Content } from 'rsuite'
import { Loader } from '../shared'

const RootLayout: React.FC = () => {
  return (
    <Container>
      <Content className="root-outlet">
        <Suspense fallback={<Loader variant="inline" />}>
          <Outlet />
        </Suspense>
      </Content>
    </Container>
  )
}

export default RootLayout
